import { render, staticRenderFns } from "./TarifsSanteActifs.vue?vue&type=template&id=1d383ef3&scoped=true&"
import script from "./TarifsSanteActifs.vue?vue&type=script&lang=js&"
export * from "./TarifsSanteActifs.vue?vue&type=script&lang=js&"
import style0 from "./TarifsSanteActifs.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./TarifsSanteActifs.vue?vue&type=style&index=1&id=1d383ef3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d383ef3",
  null
  
)

export default component.exports